import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { observer } from "mobx-react";
import * as React from "react";
import { THEME } from "../../theme/ThemeStore";
import { JobCategory } from "../../network/APITypes";
import { TableStore } from "../../stores/TableStore";
import { generalStore } from "../../stores/GeneralStore";
import { TableLine } from "../ui/TableLine";
import { optionToString } from "../util/helpers";
import { getJobCategoryOptions } from "../../constants";
import { NoResults } from "../ui/EmptyStates";
import { TableHeader } from "../ui/TableHeader";

const jobCategoryHeaderFieldIdToContent = (id: string, jobCategory: JobCategory, onEdit?: (jobCategory: JobCategory) => void) => {
    switch (id) {
        case "name":
            return (
                <div>
                    {optionToString(getJobCategoryOptions(), jobCategory.name) || jobCategory.name}
                </div>
            );
        case "isActive":
            return (
                <div
                    style={{
                        width: "100%",
                    }}
                >
                    <img
                        src={jobCategory.isActive ? THEME.Images.icVisibility : THEME.Images.icVisibilityOff}
                    />
                </div>
            );
        case "edit":
            return (
                <div style={{ width: "100%", paddingLeft: 15 }}>
                    <img
                        src={THEME.Images.icEdit}
                        style={{ cursor: "pointer" }}
                        onClick={() => onEdit?.(jobCategory)}
                    />
                </div>

            );
        default:
            return "";
    }
};

type Props = {
    jobCategories: JobCategory[];
    tableStore: TableStore;
    initialLoaded?: boolean;
    responsiveHeaderOptions: any[];
    tableCellWidthProportionsArray: number[];
    onEdit?: (jobCategory: JobCategory) => void;
};

export const JobCategoriesList = observer(({
    jobCategories,
    tableStore,
    initialLoaded,
    responsiveHeaderOptions,
    tableCellWidthProportionsArray,
    onEdit
}: Props) => {
    const loaded = !generalStore.isLoading && initialLoaded;

    return (
        <div style={{ width: "100%", maxWidth: "100%" }}>
            <Table>
                <TableHeader
                    fields={responsiveHeaderOptions}
                    flexGrowArray={tableCellWidthProportionsArray}
                    hideCheckbox={true}
                    tableStore={tableStore}
                />
                {loaded && jobCategories.length > 0 && (
                    <TableBody>
                        {jobCategories.map((jobCategory) => (
                            <TableLine
                                key={jobCategory.id}
                                id={jobCategory.id}
                                hideCheckbox={true}
                            >
                                {responsiveHeaderOptions.map((headerOption, index) => (
                                    <TableCell
                                        key={headerOption.value}
                                        className="body2"
                                        style={{
                                            flex: `${tableCellWidthProportionsArray[index] * 100}%`,
                                            display: "flex",
                                            alignItems: "center",
                                            color: THEME.customColors.headingsDark,
                                        }}
                                    >
                                        {jobCategoryHeaderFieldIdToContent(headerOption.value, jobCategory, onEdit)}
                                    </TableCell>
                                ))}
                            </TableLine>
                        ))}
                    </TableBody>
                )}
            </Table>
            {loaded && jobCategories.length === 0 && <NoResults />}
        </div>

    );
});